import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import * as AddressActions from '@redux/onboarding/address-step/address-step-action'
import * as OnboardingSelector from 'selectors/onboarding/onboarding-selector'
import * as RequestingSelector from '@selectors/requesting/requesting-selector'

import TemplateStep from '@components/layout/template-step'
import InputAddress from '@components/input/input-text/input-text'
import InputAddressNumber from '@components/input/input-text/input-text'
import InputAddressComplement from '@components/input/input-text/input-text'
import InputCity from '@components/input/input-text/input-text'
import InputDistrict from '@components/input/input-text/input-text'
import InputState from '@components/input/input-text/input-text'
import InputZipCode from '@components/input/input-zipcode/input-zipcode'

const AddressStep = () => {
  const dispatch = useDispatch()
  const address = useSelector(OnboardingSelector.address)
  const isGettingAddress = useSelector(state => RequestingSelector.selectRequesting(state, [AddressActions.REQUEST_GET_ADDRESS]))

  const getAddress = async zipCode => {
    if (zipCode.length === 8) await dispatch(AddressActions.getAddress(zipCode))
  }

  const handleChange = async ({ name, value }) => {
    if (name === 'zipCode') await getAddress(value)

    dispatch(AddressActions.setAddressField(name, value))
  }

  return (
    <TemplateStep>
      <div className="row">
        <div className="col-12 col-sm-6">
          <InputZipCode name="zipCode" value={address.zipCode} onChange={handleChange} fixedLabel label="CEP" required />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-sm-6">
          <InputAddress
            disabled={isGettingAddress}
            name="street"
            value={address.street}
            onChange={handleChange}
            fixedLabel
            label="Endereço"
            required
          />
        </div>
        <div className="col-12 col-sm-6">
          <InputAddressNumber name="number" value={address.number} onChange={handleChange} fixedLabel label="Número" required />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-sm-6">
          <InputAddressComplement name="addressComplement" value={address.addressComplement} onChange={handleChange} fixedLabel label="Complemento" />
        </div>
        <div className="col-12 col-sm-6">
          <InputDistrict
            disabled={isGettingAddress}
            name="district"
            value={address.district}
            onChange={handleChange}
            fixedLabel
            label="Bairro"
            required
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-sm-6">
          <InputCity disabled={isGettingAddress} name="city" value={address.city} onChange={handleChange} fixedLabel label="Cidade" required />
        </div>
        <div className="col-12 col-sm-6">
          <InputState disabled={isGettingAddress} name="uf" value={address.uf} onChange={handleChange} fixedLabel label="Estado" required />
        </div>
      </div>
    </TemplateStep>
  )
}

AddressStep.propTypes = {}
AddressStep.displayName = 'AddressStep_Page'

export default AddressStep
